module.exports = __webpack_public_path__ + "static/mail-icon-3cc4d71ef0d49b1de9771d3d2159a57d.png";